import React from 'react'
import {renderMoneyHideDecimal, isLZWKAPP, isMoney} from '../../utils'
import {connect} from 'react-redux'
import {Pay} from '../../components'
import {wxPay} from '../../utils/connectApp'

class WalletRechargeOption extends React.Component {
    constructor(props) {
        super(props);
        this.payMoney = this.payMoney.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleMoney = this.handleMoney.bind(this);
        this.state = {
            hasOwn: {}.hasOwnProperty,
            productId: 0,
            curIndex: 2,
            fee: 7800,
            moneyAmount: '',
            inputValue: 78
        }
    }

    classNames() {
        var classes = [];
        for (var i = 0; i < arguments.length; i++) {
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === 'string' || argType === 'number') {
                classes.push(arg);
            } else if (Array.isArray(arg)) {
                classes.push(this.classNames.apply(null, arg));
            } else if (argType === 'object') {
                for (var key in arg) {
                    if (this.state.hasOwn.call(arg, key) && arg[key]) {
                        classes.push(key);
                    }
                }
            }
        }
        return classes.join(' ');
    }

    handleSelect(item, index) {
        this.setState({
            productId: item.product_id,
            curIndex: index,
            fee: item.fee,
            isMoneyValid: true,
            moneyAmount: item.fee / 100,
            inputValue: item.fee / 100
        });
    }

    handleMoney(e) {
        const value = e.target.value;
        this.setState({
            inputValue: value,
            curIndex: '',
            moneyAmount: value,
        });

    }

    payMoney() {
        if (isMoney(this.state.inputValue)) {
            wxPay({
                product: 'iap_recharge',
                type: 'iap_recharge',
                payParams: {
                    fee: (100 * this.state.inputValue).toFixed()
                },
            });
            if (isLZWKAPP()) {
                window.payResult = (data) => {
                    if (data.code === -1) {
                        return alert('支付失败')
                    }
                    if (data.code === 0) {
                        alert('支付成功');
                        this.props.reBalance()
                    }
                }
            }
        }
        else {
            alert('请输入正确的充值金额')
        }
    }


    render() {
        return (
            <div className='wallet-recharge-option'>
                <Pay/>
                <div className='recharge-description'>
                    充值荔枝币
                </div>
                <div className='recharge-option'>
                    {this.props.rechargeList.map((item, index) =>
                        <div key={item.product_id} className='option'>
                            <div
                                className={this.classNames({
                                    'active': index === this.state.curIndex,
                                    'amount': true,
                                })}
                                onClick={(e) => this.handleSelect(item, index)}>
                                <div className='money'>{renderMoneyHideDecimal(item.fee)}元</div>
                                <div className='litchi-money'>{renderMoneyHideDecimal(item.lychee_fee)}荔枝币</div>
                            </div>
                        </div>)}
                </div>
                <div className='customize'>
                    <div className='head'>自定金额 (1元=1荔枝币)</div>
                    <div className='customizeInput'>
                        <input type='number' value={this.state.moneyAmount} placeholder='请输入充值金额，如：88.88'
                               onChange={this.handleMoney}/>
                        <div className='unit'>荔枝币</div>
                    </div>
                </div>
                <div className='pay-btn'>
                    <button className='btn' onClick={this.payMoney}>
                        确认支付
                    </button>
                </div>
                <div className='recharge-prompt'>
                    <div className='prompt-head'>温馨提示：</div>
                    <ul>
                        <li>1.因Apple政策原因，充值仅限Apple指定价格；</li>
                        <li>2.荔枝币可用于直接购买App内虚拟内容（包含课程、专栏和VIP会员等）；</li>
                        <li>3.荔枝币仅限在iOS系统消费，无法在其他系统消费；</li>
                        <li>4.荔枝币作为虚拟币，充值后荔枝币不会过期，但无法提现或转赠他人；</li>
                        <li>5.充值中有任何疑问，请联系客服。(<a href="/activity/servicepage/">客服通道</a>)</li>
                    </ul>
                </div>
            </div>
        )
    }
}

export default connect()(WalletRechargeOption)


// WEBPACK FOOTER //
// ./src/components/wallet/WalletIapRechargeOption.js